import React, { useState, useDispatch } from "reactn"

import { GatsbyImage } from "gatsby-plugin-image"
import {
  Flex,
  SimpleGrid,
  Box,
  Container,
  Select,
  Spacer,
} from "@chakra-ui/react"
import { SmallCloseIcon } from "@chakra-ui/icons"
import debounceEffect from '../utils/debounceEffect'
import { formatPrice } from "../../utils/format-price"

const CartItem = ({
  product,
  showSummary,
  showReceipt,
  checkoutOpen = false,
}) => {
  const changeProductQuantity = useDispatch("changeProductQuantity")
  const changeSize = useDispatch("changeSize")
  const removeProduct = useDispatch("removeProduct")
  const [quantity, setQuantity] = useState(product.quantity)
  const [runFetchCart, setRunFetchCart] = useState(false)
  const debouncedRunFetchCart = debounceEffect(runFetchCart, 1200)
  const [sku, setSku] = useState(product.sku)

  React.useEffect(() => {
    setQuantity(product.quantity)
  }, [product.quantity])

  React.useEffect(() => {
    if (runFetchCart == true) {
      setRunFetchCart(false)
      changeProductQuantity(product)
    }
  }, [debouncedRunFetchCart])

  function handleOnDecrease() {
    setQuantity(quantity - 1)
    product.quantity = product.quantity - 1
    setRunFetchCart(true)
  }

  function handleChangeSze(event) {
    const variant = product.variants[event.target.options.selectedIndex]
    setSku(variant.storefrontId)
    product.sku = variant.storefrontId
    changeSize(product)
  }

  function handleRemove() {
    removeProduct(product)
    setRunFetchCart(true)
  }

  function handleOnIncrease() {
    setQuantity(quantity + 1)
    product.quantity = product.quantity + 1
    setRunFetchCart(true)
  }

  return (
    <Box id="cartItem" width="100%">
      <Box mb={["2", "2", "2", "2"]}>
        <Flex id="flex" width="100%">
          <Box
            maxWidth={checkoutOpen ? ["80px", "80px", "60px", "100px", "180px"] : ["80px", "80px", "80px", "80px"]}
            minWidth={"50px"}
          >
            {showReceipt ? (
              <img fit="cover" src={product.image} />
            ) : (
              <GatsbyImage
                alt={product.title}
                title={product.title}
                image={product.image}
                draggable={false}
              />
            )}
          </Box>
          <Box mt={[2, 2, 2, 10]} width="100%">
            <Container variant="cartText">
              {product.title}
              {(showReceipt || showSummary) && (
                <Box mt={["0", "0", "0", "2"]}>
                  <Flex>
                    <Box mt={2} textTransform={"lowercase"}>
                      {quantity} x {formatPrice(product.price)}
                    </Box>
                    <Box mt={2} flex="1" mr={0} w={8} h={8} textAlign={"right"}>
                      <b>{formatPrice(product.price * quantity)} </b>
                    </Box>
                  </Flex>
                </Box>
              )}
            </Container>
          </Box>
          {!showReceipt && !showSummary && (
            <Box
              mt={2}
              flex="1"
              mr={0}
              w={8}
              h={8}
              onClick={handleRemove}
              textAlign={"right"}
            >
              <SmallCloseIcon
                ml={0}
                mt={3}
                color="brandWhite.500"
                _hover={{ color: "black" }}
              />
            </Box>
          )}
        </Flex>
        {!showReceipt && !showSummary && product.variants[0]?.title !== 'Default Title' && (
          <Container ml={0} mt={3} p={0} fontSize={14}>
            SIZE
          </Container>
        )}
        {!showReceipt && !showSummary && product.variants[0]?.title !== 'Default Title' && (
          <Select
            mb={3}
            minH={"50px"}
            onChange={handleChangeSze}
            _focus={{ borderColor: "black" }}
            _hover={{ borderColor: "colorWhite.800" }}
            borderColor="black"
            borderWidth="3px"
            value={sku}
          >
            {product.variants.map((v, i) => (
              <option key={`var${i}`} value={v.storefrontId}>{v.title}</option>
            ))}
          </Select>
        )}
        {!showReceipt && !showSummary && (
          <Container ml={0} mt={3} p={0} fontSize={14}>
            QUANTITY
          </Container>
        )}
        {!showReceipt && !showSummary && (
          <SimpleGrid columns={3} spacing="4px">
            <Box>
              <Flex
                minH={"50px"}
                borderWidth="3px"
                spacing={5}
                borderColor="black"
              >
                <Box
                  ml={3}
                  fontSize={28}
                  onClick={handleOnDecrease}
                  disabled={quantity === 1 ? true : false}
                  className="change-product-button change-product-button-left"
                >
                  -
                </Box>
                <Spacer />
                <Box ml={1} mr={1} mt={2}>
                  {quantity}
                </Box>
                <Spacer />
                <Box
                  mr={3}
                  fontSize={28}
                  onClick={handleOnIncrease}
                  className="change-product-button change-product-button-right"
                >
                  +
                </Box>
              </Flex>
            </Box>
            <Spacer />
            <Box pr={4} mt={5} fontSize={"14px"} textAlign={"right"}>
              {formatPrice(product.price)}
            </Box>
            <Box className="column del_column">
              <div
                className="shelf-item__del"
                onClick={() => removeProduct(product)}
              />
            </Box>
          </SimpleGrid>
        )}
      </Box>
    </Box>
  )
}

export default CartItem